export default __webpack_public_path__ + "static/media/facebook.0f7e003e.svg";